(() => {
  // Welke pannensets meedoen komt uit de Shopify-collectie "pannenset-actie" (via layout/theme.liquid).
  // Product toevoegen/verwijderen in die collectie = actie aan/uit. Geen lijst meer om bij te houden.
  if (!Array.isArray(window.VATA_PAN_ACTIE_IDS)) return;
  const QUALIFYING_PAN_PRODUCT_IDS = new Set(window.VATA_PAN_ACTIE_IDS.map(String));
  const GIFT_VARIANT_ID = '57261132579156';
  const GIFT_PROPERTY_KEY = '_vata_free_gift';
  const GIFT_PROPERTY_VALUE = 'pannenset-maestro-actie';
  let syncing = false;

  const originalFetch = window.fetch.bind(window);

  function isCartUrl(input) {
    const url = typeof input === 'string' ? input : input && input.url;
    return typeof url === 'string' && /\/cart(?:\/|\?|$)/.test(url);
  }

  async function getCart() {
    const response = await originalFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  async function isGiftAvailable() {
    try {
      const response = await originalFetch('/products/mandoline-groentesnijder-16-delig.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return false;
      const product = await response.json();
      return product && product.available === true;
    } catch (error) {
      return false;
    }
  }

  function hasQualifyingPan(cart) {
    return cart.items.some((item) =>
      QUALIFYING_PAN_PRODUCT_IDS.has(String(item.product_id)) && item.quantity > 0
    );
  }

  function getGiftLine(cart) {
    return cart.items.find((item) =>
      String(item.variant_id) === GIFT_VARIANT_ID &&
      item.properties &&
      item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE
    );
  }

  async function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  async function changeLine(key, quantity) {
    await originalFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  async function syncGift() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();
      const qualifyingPan = hasQualifyingPan(cart);
      const giftLine = getGiftLine(cart);
      const giftAvailable = await isGiftAvailable();

      if (giftLine && !giftAvailable) {
        await changeLine(giftLine.key, 0);
        await refreshCartUi();
      } else if (qualifyingPan && giftAvailable && !giftLine) {
        await originalFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(GIFT_VARIANT_ID),
              quantity: 1,
              properties: { [GIFT_PROPERTY_KEY]: GIFT_PROPERTY_VALUE }
            }]
          })
        });
        await refreshCartUi();
      } else if (!qualifyingPan && giftLine) {
        await changeLine(giftLine.key, 0);
        await refreshCartUi();
      } else if (giftLine && giftLine.quantity !== 1) {
        await changeLine(giftLine.key, 1);
        await refreshCartUi();
      }
    } finally {
      syncing = false;
    }
  }

  window.fetch = async function(input, init) {
    const response = await originalFetch(input, init);
    if (isCartUrl(input)) {
      Promise.resolve().then(syncGift);
    }
    return response;
  };

  document.addEventListener('cart:updated', () => {
    if (!syncing) Promise.resolve().then(syncGift);
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncGift();
  });

  syncGift();
})();
